import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const titleSx = {
  color: BLACK[100],
  fontFamily: PRIMARY_FONT[500],
  fontSize: '15px',
  lineHeight: '36px',
};

const SectionTitle = ({ children }) => (
  <Typography component="h2" sx={titleSx}>
    {children}
  </Typography>
);

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SectionTitle;
